module.exports = __webpack_public_path__ + "static/greybunny2-ddb3c56912786f1f1d039fb049c7ca09.png";